import { render } from "./ExamStudentsModal.vue?vue&type=template&id=6e006020&scoped=true"
import script from "./ExamStudentsModal.vue?vue&type=script&lang=js"
export * from "./ExamStudentsModal.vue?vue&type=script&lang=js"

import "./ExamStudentsModal.vue?vue&type=style&index=0&id=6e006020&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e006020"]])

export default __exports__